function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Option, Select } from '@deephaven/components';
import { useApi } from '@deephaven/jsapi-bootstrap';
import { EMPTY_ARRAY } from '@deephaven/utils';
import { jsx as _jsx } from "react/jsx-runtime";
function isJavaObject(value) {
  return typeof value === 'object' && value != null && 'equals' in value && typeof value.equals === 'function';
}
function defaultFormatValue(value) {
  return "".concat(value);
}
/**
 * Dropdown that displays the values of a column in a table.
 */
export function TableDropdown(_ref) {
  var column = _ref.column,
    table = _ref.table,
    _ref$filter = _ref.filter,
    filter = _ref$filter === void 0 ? EMPTY_ARRAY : _ref$filter,
    onChange = _ref.onChange,
    selectedValue = _ref.selectedValue,
    disabled = _ref.disabled,
    className = _ref.className,
    _ref$formatValue = _ref.formatValue,
    formatValue = _ref$formatValue === void 0 ? defaultFormatValue : _ref$formatValue,
    _ref$maxSize = _ref.maxSize,
    maxSize = _ref$maxSize === void 0 ? 1000 : _ref$maxSize;
  var dh = useApi();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    values = _useState2[0],
    setValues = _useState2[1];
  useEffect(() => {
    if (table == null) {
      setValues([]);
      return undefined;
    }
    var tableColumn = column !== null && column !== void 0 ? column : table.columns[0];
    // Need to set a viewport on the table and start listening to get the values to populate the dropdown
    table.applyFilter(filter);
    var subscription = table.setViewport(0, maxSize, [tableColumn]);
    subscription.addEventListener(dh.Table.EVENT_UPDATED, event => {
      var detail = event.detail;
      // Core JSAPI returns undefined for null table values,
      // coalesce with null to differentiate null from no selection in the dropdown
      // https://github.com/deephaven/deephaven-core/issues/5400
      var newValues = detail.rows.map(row => {
        var _row$get;
        return (_row$get = row.get(tableColumn)) !== null && _row$get !== void 0 ? _row$get : null;
      });
      setValues(newValues);
    });
    return () => {
      subscription.close();
    };
  }, [column, dh, filter, maxSize, table]);

  // If the selected value is undefined, add a placeholder item
  var allValues = useMemo(() => {
    if (selectedValue === undefined) {
      return [undefined, ...values];
    }
    return values;
  }, [selectedValue, values]);

  // Since values could be anything, not just strings, track the selected index based on the current data
  var selectedIndex = useMemo(() => allValues.findIndex(value => value === selectedValue || isJavaObject(value) && value.equals(selectedValue)), [selectedValue, allValues]);
  var handleChange = useCallback(newSelectedValue => {
    var newSelectedIndex = parseInt(newSelectedValue, 10);
    onChange(allValues[newSelectedIndex]);
  }, [onChange, allValues]);
  return /*#__PURE__*/_jsx(Select, {
    className: className,
    value: selectedIndex,
    onChange: handleChange,
    disabled: disabled,
    children: allValues.map((value, i) =>
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    _jsx(Option, {
      value: i,
      children: formatValue(value)
    }, "".concat(i)))
  });
}
export default TableDropdown;
//# sourceMappingURL=TableDropdown.js.map